module.exports = __webpack_public_path__ + "images/bug_light_blue_size_6_5a3575be9a566804c27b6c2c1e6c0689.png";